import { LegacyRoute } from '../routesMiddleware';
import ExpertPaymentsRoute from './ExpertPaymentsRoute';

/**
 * The internal accounts-payable console (ENG-5624 / FE7).
 *
 * Lives at `/admin/expert-payments` — under the admin tree because that is where
 * staff look for staff tools, but NOT as an `/admin/:model` entry. That tree is
 * one catch-all route dispatching a generic model-CRUD scaffold; a bespoke
 * settlement console is not a `:model`, and registering it as one would drag in
 * v1 chrome the console does not use.
 *
 * React Router ranks static segments above dynamic ones, so this wins over
 * `/admin/:model?/:id?` whatever the order in the route array — pinned by a test
 * rather than trusted silently, because losing that race would put a generic
 * CRUD scaffold where the money screen should be.
 *
 * Registered always; the feature gate is checked inside the route component, so
 * the environment variable takes effect without rebuilding the route tree.
 */
const expertPayments: LegacyRoute = {
  path: '/admin/expert-payments',

  async action() {
    document.title = 'Expert payments';
    return <ExpertPaymentsRoute />;
  },
};

export default expertPayments;
